<div class="col-md-12 padding-left-0px padding-right-0px">
  <div class="row margin-left-0px margin-right-0px" *ngIf="field">
    <div class="col-md-6 padding-left-0px padding-right-0px text-align-left">
      <label class="margin-bottom-0px font-family"> {{field.Title}}</label>
    </div>
    
  </div>

  <div class="row" *ngIf="field.Value &&  Data  && Data.HasChildren">

    <auto-gen-childrenpv class="col-md-12 padding-left-0px padding-right-0px" [Data]="Data" [field]="Data.Data"></auto-gen-childrenpv>

  </div>
  <!--<div class="row" *ngIf="!field.Value &&  Data  && Data.HasChildren">
    {{field.Title}} has no field value !!!
    <auto-gen-children class="col-12" [Data]="Data" [field]="Data.Data"></auto-gen-children>
    

  </div>-->

</div>
